import polyglotI18nProvider from 'ra-i18n-polyglot';
import { tr } from './tr';
import { en } from './en';

const translations = { tr, en };

export const i18nProvider = polyglotI18nProvider(
  (locale) => translations[locale] || translations.tr,
  'tr', // Default locale is Turkish
  [
    { locale: 'tr', name: 'Türkçe' },
    { locale: 'en', name: 'English' },
  ],
);
